<template>
  <div id="pageTrack">
    <div class="top">
      <v-img 
        contain
        max-height="30" 
        src="https://firebasestorage.googleapis.com/v0/b/portal-ecotrace-dev.appspot.com/o/app-resources%2Flogo-ecotrace-200w.png?alt=media&token=41f6563f-17fc-4305-8185-4313bbcc4974"></v-img>
    </div>
    <v-container>
      <v-card v-if="track">
        <v-card-text>
          <v-row>
            <v-col md="6" cols="12">

              <v-row>
                <v-col>
                  <strong>Origem</strong>
                  <div>{{track.origin.name}}</div>
                </v-col>
                <v-col>
                  <strong>Cidade</strong>
                  <div>{{track.origin.city}} / {{track.origin.state}}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <strong>Data de Produção</strong>
                  <div>{{track.production_date | formatDate}}</div>
                </v-col>
                <v-col v-if="track.animal && track.animal.breed">
                  <strong>Raça</strong>
                  <div>{{track.animal.breed}}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <strong>Destino</strong>
                  <div>{{track.destiny.name}}</div>
                </v-col>
                <v-col>
                  <strong>CNPJ</strong>
                  <div>{{track.destiny.document_number | formatCpfCnpj}}</div>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <strong>Telefone</strong>
                  <div>{{track.destiny.phone}}</div>
                </v-col>
                <v-col>
                  <strong>E-mail</strong>
                  <div>{{track.destiny.email}}</div>
                </v-col>
              </v-row>

            </v-col>
            <v-col md="6" cols="12">
              <div id="map"></div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import Vue from 'vue'
import appApi from '@/plugins/api';

export default {
  components: {

  },
  data: function() {
    return {
      track : null,
      geocoder : null
    }
  },

  computed: {

  },

  mounted: function() {
    let data = {
      track_id : this.$route.query.track_id
    }
    if (this.$route.query.nr) {
      data['nr'] = this.$route.query.nr
    }
    appApi.getTrack(data)
      .then( result => {
        this.track = result.data
        this.geocoder = new google.maps.Geocoder();
        this.codeAddress(this.track.origin.city+", "+this.track.origin.state, (resOrigin) => {
          this.codeAddress(this.track.destiny.city+", "+this.track.destiny.state, (resDestiny) => {
            this.printMap(this.track, resOrigin, resDestiny)
          });
        });
      })
      .catch(err => {

      })
  },

  methods: {

    codeAddress(address, callback) {
      this.geocoder.geocode( { 'address': address}, function(results, status) {
        if (status == 'OK') {
          var loc = results[0].geometry.location;
          callback({lat: loc.lat(), lng: loc.lng()});
        } else {
      
        }
      });
    },
    printMap(r, resFazenda, resIndustria) {
      let map = new google.maps.Map(document.getElementById('map'), {
        zoom: 7,
        center: this.middlePoint(resFazenda.lat, resFazenda.lng, resIndustria.lat, resIndustria.lng),
        mapTypeId: 'terrain'
      });

      var mf = new google.maps.Marker({
        position: resFazenda,
        map: map,
        title: r.origin.name
      });

      var mi = new google.maps.Marker({
        position: resIndustria,
        map: map,
        title: r.destiny.name
      });

      var infoF = new google.maps.InfoWindow({
        content: r.origin.name
      });
      infoF.open(map, mf);

      var infoI = new google.maps.InfoWindow({
        content: r.destiny.name
      });
      infoI.open(map, mi)

      var citiesCoordinates = [
        resFazenda,
        resIndustria
      ];
      var rastreioPath = new google.maps.Polyline({
        path: citiesCoordinates,
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 2
      });

      rastreioPath.setMap(map);

    },
    middlePoint(lat1, lng1, lat2, lng2) {
      if (typeof(Number.prototype.toRad) === "undefined") {
        Number.prototype.toRad = function() {
          return this * Math.PI / 180;
        }
      }

      if (typeof(Number.prototype.toDeg) === "undefined") {
        Number.prototype.toDeg = function() {
          return this * 180 / Math.PI
        }
      }
      //-- Longitude difference
      var dLng = (lng2 - lng1).toRad();

      //-- Convert to radians
      lat1 = lat1.toRad();
      lat2 = lat2.toRad();
      lng1 = lng1.toRad();

      var bX = Math.cos(lat2) * Math.cos(dLng);
      var bY = Math.cos(lat2) * Math.sin(dLng);
      var lat3 = Math.atan2(Math.sin(lat1) + Math.sin(lat2), Math.sqrt((Math.cos(lat1) + bX) * (Math.cos(lat1) + bX) + bY * bY));
      var lng3 = lng1 + Math.atan2(bY, Math.cos(lat1) + bX);

      //-- Return result
      return {lat: lat3.toDeg(), lng: lng3.toDeg()}
    }

  },

};
</script>
<style scoped lang="css">
  #pageTrack {
    background-color: #2B922B;
    height: 100%;
  }

  #pageTrack .top {
    background-color: #fff;
    padding: 20px;
  }
  #pageTrack .content {
    background-color: #fff;
    padding: 20px;
  }

  #pageTrack #map {
    width: 100%;
    height: 300px;
  }
</style>

